// extracted by mini-css-extract-plugin
export var cardHeader = "_jd-1";
export var contentCard = "_jd-0";
export var headerActions = "_jd-3";
export var reorderHandle = "_jd-5";
export var titleArea = "_jd-2";
export var titleAreaWithHandle = "_jd-4";